import { Box, TextField, Grid, Typography, Divider, MenuItem } from '@mui/material';
import { Field, useFormikContext } from 'formik';


type SectorFormProps = {
  mode: 'create' | 'edit' | 'view';
  loading?: boolean;
};

export function SectorForm({
  mode,
  loading = false,
}: SectorFormProps) {
  const { errors, touched } = useFormikContext<any>();
  const isView = mode === 'view';



  return (
    <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
      <Typography variant="h6" fontWeight={700} color="primary.main" mb={1} mt={1}>
        Dados do Setor
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item  xs={12}>
          <Field
            as={TextField}
            label="Nome"
            name="name"
            fullWidth
            required
            disabled={isView || loading}
            error={!!(touched.name && errors.name)}
            helperText={touched.name && errors.name}
          />
        </Grid>
       
        <Grid item xs={12}>
          <Field
            as={TextField}
            label="Descrição"
            name="description"
            fullWidth
            multiline
            minRows={2}
            disabled={isView || loading}
            error={!!(touched.description && errors.description)}
            helperText={touched.description && errors.description}
          />
        </Grid>
      </Grid>
    </Box>
  );
}